import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { LANGUAGES } from "@/i18n";
import API from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const NOTIFS = [
  ["new_request", "Nuova richiesta compatibile"],
  ["new_availability", "Nuova disponibilità"],
  ["new_message", "Nuovo messaggio"],
  ["contact_shared", "Contatti condivisi"],
  ["review", "Nuova recensione"],
];

export default function Settings() {
  const { language, setLanguage } = useApp();
  const { user, refresh } = useAuth();
  const [prefs, setPrefs] = useState(user?.notification_prefs || {});

  useEffect(() => { setPrefs(user?.notification_prefs || {}); }, [user]);

  const saveLang = async (l) => { setLanguage(l); await API.put("/me/settings", { language: l }); toast.success("Lingua aggiornata"); };
  const toggle = async (k) => {
    const next = { ...prefs, [k]: !prefs[k] };
    setPrefs(next);
    await API.put("/me/settings", { notification_prefs: next });
    refresh();
  };

  return (
    <Layout>
      <h1 className="font-serif text-2xl font-bold text-[#0F1230] mb-4">Impostazioni</h1>

      <div className="bg-white rounded-[18px] border border-[#DADFEA] p-5 mb-4">
        <h2 className="font-semibold text-[#0F1230] mb-3">Lingua</h2>
        <div className="flex flex-wrap gap-2">
          {LANGUAGES.map((l) => (
            <button key={l.code} data-testid={`settings-lang-${l.code}`} onClick={() => saveLang(l.code)} className={`px-3 h-10 rounded-full text-sm border ${language === l.code ? "bg-[#1F4FE0] text-white border-[#1F4FE0]" : "border-[#DADFEA]"}`}>{l.label}</button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-[18px] border border-[#DADFEA] p-5">
        <h2 className="font-semibold text-[#0F1230] mb-3">Notifiche</h2>
        <div className="space-y-3">
          {NOTIFS.map(([k, label]) => (
            <label key={k} className="flex items-center justify-between">
              <span className="text-sm text-[#2A2E48]">{label}</span>
              <Switch data-testid={`notif-${k}`} checked={!!prefs[k]} onCheckedChange={() => toggle(k)} />
            </label>
          ))}
        </div>
      </div>
    </Layout>
  );
}
